import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type InvitationRevokedPayload = UserPayload;

export type InvitationRevokedAction = {
	type: 'INVITATION_REVOKED';
	payload: InvitationRevokedPayload;
	accountId: number;
};

export default (payload: InvitationRevokedPayload, accountId: number): InvitationRevokedAction => ({
	type: 'INVITATION_REVOKED',
	payload,
	accountId,
});
